import TabelaCodTribNacService from "@/services/TabelaCodTribNacService";

export const tabelaCodTribNac = {
  namespaced: true,
  state: {
    tabelaCodTribNac: {},
  },
  actions: {
    getTabelaCodTribNac({ commit }, payload) {
      return TabelaCodTribNacService.GetTabelaCodTribNac(payload).then(
        (tabelaCodTribNac) => {
          return Promise.resolve(tabelaCodTribNac);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTabelaCodTribNac({ commit }, payload) {
      return TabelaCodTribNacService.PostTabelaCodTribNac(payload).then(
        (tabelaCodTribNac) => {
          return Promise.resolve(tabelaCodTribNac);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTabelaCodTribNac({ commit }, payload) {
      return TabelaCodTribNacService.PutTabelaCodTribNac(payload).then(
        (tabelaCodTribNac) => {
          return Promise.resolve(tabelaCodTribNac);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTabelaCodTribNac({ commit }, payload) {
      return TabelaCodTribNacService.DeleteTabelaCodTribNac(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTabelaCodTribNacOData({ commit }, payload) {
      return TabelaCodTribNacService.GetTabelaCodTribNacOData(payload).then(
        (tabelaCodTribNac) => {
          return Promise.resolve(tabelaCodTribNac);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    atualizarTabelaCodTribNac({ commit }, payload) {
      return TabelaCodTribNacService.AtualizarTabelaCodTribNac(payload).then(
        (tabelaCodTribNac) => {
          return Promise.resolve(tabelaCodTribNac);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default tabelaCodTribNac;
